import { sysURL } from '../constants';
import { httpClient } from './../utils/HttpClient';
import * as M from '../reducers/settingPermission.reducer';

//redirect to login page

//load Count Summary Data Group ";
export const setSettingPermissionStateToFetching = () => ({
  type: M.SETTING_PERMISSION_FETCHING,
});

export const setSettingPermissionStateToFailed = () => ({
  type: M.SETTING_PERMISSION_FAILED,
});

export const setSettingPermissionStateToSuccess = (payload) => ({
  type: M.SETTING_PERMISSION_SUCCESS,
  payload,
});

export const loadSettingPermission = ({
  columnOrder,
  isAscending,
  pageNo,
  perPage,
  search,
}) => {
  let api = 'permissiongroup/v1/getListAllPagingWithUserRight';
  let url = api;
  return async (dispatch, getState) => {
    try {
      dispatch(setSettingPermissionStateToFetching());

      let result = await httpClient.post(url, {
        perPage: perPage,
        pageNo: pageNo,
        columnOrder: columnOrder,
        isAscending: isAscending,
        search: search,
      //  searchObj: search,
      });

      if (result.data.status == true) {
        dispatch(setSettingPermissionStateToSuccess(result.data));
      } else {
        dispatch(setSettingPermissionStateToFailed([]));
      }

      // let dataMock = {
      //   content: {
      //     data: [
      //       {
      //         id: '1',
      //         fullName: 'uaychai saengfa',
      //         permissionType: 'level 1 ',
      //       },
      //       {
      //         id: '2',
      //         fullName: 'uaychai saengfa',
      //         permissionType: 'level 1 ',
      //       },
      //       {
      //         id: '3',
      //         fullName: 'uaychai saengfa',
      //         permissionType: 'level 1 ',
      //       },
      //       {
      //         id: '4',
      //         fullName: 'uaychai saengfa',
      //         permissionType: 'level 1 ',
      //       },
      //       {
      //         id: '5',
      //         fullName: 'uaychai saengfa',
      //         permissionType: 'level 1 ',
      //       },
      //       {
      //         id: '6',
      //         fullName: 'uaychai saengfa',
      //         permissionType: 'level 1 ',
      //       },
      //       {
      //         id: '7',
      //         fullName: 'uaychai saengfa',
      //         permissionType: 'level 1 ',
      //       },
      //       {
      //         id: '8',
      //         fullName: 'uaychai saengfa',
      //         permissionType: 'level 1 ',
      //       },
      //       {
      //         id: '9',
      //         fullName: 'uaychai saengfa',
      //         permissionType: 'level 1 ',
      //       },
      //       {
      //         id: '10',
      //         fullName: 'uaychai saengfa',
      //         permissionType: 'level 1 ',
      //       },
      //     ],
      //     countRow: 10,
      //   },
      // };
      //dispatch(setSettingPermissionStateToSuccess(dataMock));
    } catch (error) {
      console.log(error);
      dispatch(setSettingPermissionStateToFailed({ data: { message: error } }));
    }

    return getState().SettingPermissionReducer.result.content;
  };
};

//delete data ";
export const setSettingPermissionDeleteStateToFetching = () => ({
  type: M.SETTING_PERMISSION_DELETE_FETCHING,
});

export const setSettingPermissionDeleteStateToFailed = () => ({
  type: M.SETTING_PERMISSION_DELETE_FAILED,
});

export const setSettingPermissionDeleteStateToSuccess = (payload) => ({
  type: M.SETTING_PERMISSION_DELETE_SUCCESS,
  payload,
});

export const deleteSettingPermission = (data) => {
  let api = 'permissiongroup/v1/' + data;
  let url = api;
  return async (dispatch) => {
    try {
      dispatch(setSettingPermissionDeleteStateToFetching());

      let result = await httpClient.delete(url);

      if (result.data.status == true) {
        dispatch(setSettingPermissionDeleteStateToSuccess(result.data));
      } else {
        dispatch(setSettingPermissionDeleteStateToFailed([]));
      }
    } catch (error) {
      console.log(error);
      dispatch(
        setSettingPermissionDeleteStateToFailed({ data: { message: error } })
      );
    }

    // return getState().SettingPermissionReducer.result.content;
  };
};
